//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The grant type enum
*
* 
*  * PASSWORD value: password - password grant type 
*  * AUTHORIZATION_CODE value: authorization_code - authorization code grant type 
*  * REFRESH_TOKEN value: refresh_token - refresh token grant type 
*/
@Serializable
enum class GrantType(val value: kotlin.String) {

    @SerialName(value = "password")
    PASSWORD("password"),

    @SerialName(value = "authorization_code")
    AUTHORIZATION_CODE("authorization_code"),

    @SerialName(value = "refresh_token")
    REFRESH_TOKEN("refresh_token");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is GrantType) "$data" else null

    /**
    * Returns a valid [GrantType] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): GrantType? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

